import { Flex, Text } from "@chakra-ui/react";
import { Price } from "../../../types";

export interface PriceDisplayProps {
  price: Price;
  originalPrice?: Price;
  hasDiscount?: boolean;
}

export function PriceDisplay({
  price,
  originalPrice,
  hasDiscount,
}: PriceDisplayProps) {
  return (
    <Flex align="center" gap={2}>
      {hasDiscount && originalPrice ? (
        <>
          <Text fontSize="14px" fontWeight="700" color="success.500">
            {price.display_price_discounted}
          </Text>
          <Text
            fontSize="14px"
            fontWeight="700"
            textDecorationLine="line-through"
            color="neutral.400"
          >
            {originalPrice.display_price}
          </Text>
        </>
      ) : (
        <Text fontSize="14px" fontWeight="700">
          {price.display_price}
        </Text>
      )}
    </Flex>
  );
}
